export default __webpack_public_path__ + "static/drinking_fountain_w.0ba42cc6297686d6d68e45a38b128741.png";